import React from "react";
import PieChart from "highcharts-react-official";
import Highcharts from "highcharts/highstock";
import drilldow from "highcharts/modules/drilldown";
import { Box } from "@mui/material";

drilldow(Highcharts);
export const ScopeEmissionPieChart = (sitesEmissionsData: any) => {
  const categories = ["Scope 1", "Scope 2"];
  const data = [
    {
      y: sitesEmissionsData?.sitesEmissionsData?.totalScope1Emission,
      color: "#9EE766",
      drilldown: {
        name: "Scope 1",
        categories: ["scope"],
        data: [sitesEmissionsData?.sitesEmissionsData?.totalScope1Emission],
      },
    },
    {
      y: sitesEmissionsData?.sitesEmissionsData?.totalScope2Emission,
      color: "#57BEED",
      drilldown: {
        name: "Scope 2",
        categories: ["scope"],
        data: [sitesEmissionsData?.sitesEmissionsData?.totalScope2Emission],
      },
    },
  ];

  const browserData = [];
  const versionsData = [];
  let i;
  let j;
  const dataLen = data.length;
  let drillDataLen;
  let brightness;

  // Build the data arrays
  for (i = 0; i < dataLen; i += 1) {
    // add browser data
    browserData.push({
      name: categories[i],
      y: data[i].y,
      color: data[i].color,
    });

    // add version data
    drillDataLen = data[i].drilldown.data.length;
    for (j = 0; j < drillDataLen; j += 1) {
      brightness = 0.2 - j / drillDataLen / 5;
      versionsData.push({
        name: data[i].drilldown.categories[j],
        y: data[i].drilldown.data[j],
        color: Highcharts.color(data[i].color).brighten(brightness).get(),
      });
    }
  }

  // Create the chart
  const options: any = {
    chart: {
      type: "pie",
      height: 280,
      width: 280,
    },
    title: {
      y: 115,
      x: 0,
      floating: true,
      text: `<div style="display: flex; flex-direction: column; text-align: center; vertical-align: center; align-items: center; justify-content: center;">
        <span style="font-size: 12px"; color: "#737373";>Net Emissions</span>
        <span style="font-size: 20px; font-weight: 700;">
          ${sitesEmissionsData?.sitesEmissionsData.totalCo2Emission} tCO2eq
        </span>
      </div>`,
    },
    plotOptions: {
      pie: {
        innerSize: "10%",
        showInLegend: false,
      },
    },

    tooltip: {
      valueSuffix: " tC02",
    },

    credits: {
      enabled: false,
    },
    series: [
      {
        name: "scope",
        data: browserData,
        size: "100%",
        innerSize: "70%",
        dataLabels: {
          enabled: false,
          color: "#FAFAFA",
          distance: 0,
        },
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 100,
          },
          chartOptions: {
            series: [
              {},
              {
                id: "versions",
                dataLabels: {
                  enabled: false,
                },
              },
            ],
          },
        },
      ],
    },
  };

  return (
    <Box sx={{
      width: "300px",
      height: "157px",
      "@media (max-width: 1656px)": {
        width: "270px",
        height: "134px",
      },
    }}>
      <PieChart highcharts={Highcharts} options={options} />
    </Box>
  );
};